module.exports = __webpack_public_path__ + "static/meramaan-54c2d624a26342b16982e70fd82b0321.png";